import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AddIbanRegion, AddIbanRegionError, AddIbanRegionSuccess, DeleteIbanRegion, DeleteIbanRegionError, DeleteIbanRegionSuccess, IbanRegionsError, IbanRegionsLoaded, IbanRegionsRequested, UpdateIbanRegion, UpdateIbanRegionError, UpdateIbanRegionSuccess } from './ibanRegions.actions';
import { ClientService } from '../../@core/data/clients/client.service';
import { co } from '@fullcalendar/core/internal-common';
import { IbanRegionService } from '../../@core/data/iban-region/iban-region.service';
import { ToastrConfigs } from '../../@core/data/toastr-config';
import { NbToastrService } from '@nebular/theme';


@Injectable()
export class IbanRegionsEffects {
  constructor(
    private actions$: Actions,
    private ibanRegionService: IbanRegionService,
    private toastrService: NbToastrService
  ) {}

  requestIbanRegions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(IbanRegionsRequested),
      mergeMap(() =>
        this.ibanRegionService.getIbanRegions('').pipe(
          map((res: any) => { 
            return IbanRegionsLoaded({ ibanRegions: res?.data })}),
          catchError((error: any) => of(IbanRegionsError()))
        ) 
      )
    )
  );

  addIbanRegion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddIbanRegion),
      mergeMap((action) =>
        this.ibanRegionService.saveIbanRegion(action.ibanRegion, action.userId).pipe(
          map((response: any) => {
            const ibanRegionWithId = { ...action.ibanRegion, id: response.data };
            this.toastrService.success('IBAN Regiune adaugat cu succes', 'Success', { ...ToastrConfigs.success });
            return AddIbanRegionSuccess({ ibanRegion: ibanRegionWithId });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare adaugare IBAN Regiune', 'Error', { ...ToastrConfigs.danger });
            return of(AddIbanRegionError());
          })
        )
      )
    )
  );
  updateIbanRegion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateIbanRegion),
      mergeMap((action) =>
        this.ibanRegionService.updateIbanRegion(action.ibanRegion).pipe(
          map((response: any) => {
            const updatedIbanRegion = { ...action.ibanRegion, id: response.data };
            this.toastrService.success('IBAN Regiune actualizat cu succes', 'Success', { ...ToastrConfigs.success });
            return UpdateIbanRegionSuccess({ ibanRegion: updatedIbanRegion  });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare actualizare IBAN Regiune', 'Error', { ...ToastrConfigs.danger });
            return of(UpdateIbanRegionError());
          })
        )
      )
    )
  );

  deleteIbanRegion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteIbanRegion),
      mergeMap(action =>
        this.ibanRegionService.deleteIbanRegion(action.ibanRegionId).pipe(
          map(() => {
            this.toastrService.success('IBAN Regiune sters cu succes', 'Success', { ...ToastrConfigs.success });
            return DeleteIbanRegionSuccess({ ibanRegionId: action.ibanRegionId });
          }),
          catchError(() => {
            this.toastrService.danger('Eroare stergere IBAN Regiune', 'Error', { ...ToastrConfigs.danger });
            return of(DeleteIbanRegionError());
          })
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(IbanRegionsError),
        tap(() => {
        })
      ),
    { dispatch: false }
  );
}
